export const language = {
  en: {
    'Number': 'Number',
    'Price': 'Price',
    'Stock': 'Stock',
    'Ships From': 'Ships From',
    'Specifications': 'Specifications',
    'Quantity': 'Quantity',
    'Import': 'Import',
    'Base': 'Base',
    'Add to Cart': 'Add to Cart',
    'Add to Planned Order': 'Add to Planned Order',
    'Contact Supplier': 'Contact Supplier',
    'Supplier Details': 'Supplier Details',
    'CP': 'CP',
    'Major': 'Major',
    'Address': 'Address',
    'Supplier': 'Supplier',
    'Buyer': 'Buyer',
    'Product Details': 'Product Details',
    'Brand': 'Brand',
    'Shelf Life': 'Shelf Life',
    'Storage': 'Storage',
    'Place of Origin': 'Place of Origin',
    'Import Tariffs': 'Import Tariffs',
    'VAT': 'VAT',
    'Manufacturer': 'Manufacturer',
    'Type': 'Type',
    'Standard or not': 'Standard or not',
    'CP or not': 'CP or not',
    'Physical/Virtual': 'Physical/Virtual',
    'Ship to': 'Ship to',
    'You may also like': 'You may also like',
    'Contacts': 'Contacts',
    'Contact Information': 'Contact Information',
    'Yes': 'Yes',
    'No': 'No',
    'Physical': 'Physical',
    'Virtual': 'Virtual',
    'On Lining': 'On Lining',
    'Product Recommendation List': 'Product Recommendation List',
    'List of imported goods': 'List of imported goods',
    'Tax Included': 'Tax Included',
    'Tax Price None': '',
    'MOQ': 'MOQ',
  },

  zh: {
    'Contacts': '联系人',
    'Contact Information': '联系方式',
    'Number': '编号',
    'Price': '销售价',
    'Stock': '库存',
    'Ships From': '发货地',
    'Specifications': '商品规格',
    'Quantity': '商品数量',
    'Import': '进口',
    'Base': '基地',
    'Add to Cart': '加入购物车',
    'Add to Planned Order': '加入计划清单',
    'Contact Supplier': '联系供应商',
    'Supplier Details': '供应商详情',
    'CP': '正大集团',
    'Major': '主营',
    'Address': '公司地址',
    'Supplier': '供应商',
    'Buyer': '采购商',
    'Product Details': '商品详情',
    'Brand': '品牌',
    'Shelf Life': '保质期',
    'Storage': '储藏方式',
    'Place of Origin': '产地',
    'Import Tariffs': '进口关税',
    'VAT': '增值税率',
    'Manufacturer': '生产厂商',
    'Type': '商品类型',
    'Standard or not': '是否标品',
    'CP or not': '集团商品',
    'Physical/Virtual': '实物/虚物',
    'Ship to': '可销往国家',
    'You may also like': '商品推荐',
    'Yes': '是',
    'No': '否',
    'Physical': '实物',
    'Virtual': '虚物',
    'On Lining': '该功能即将上线',
    'Tax Included': '预估含税价',
    'Tax Price None': '(未税价)',
    'MOQ': '起订量',
  }

};